import { SelectChangeEvent } from "src/components/MuiGenerals";
import { useBatchApproveAllowanceFormContext } from "../../../contexts";
import ChainNameSelection from "src/components/ApproveAllowance/ChainNameSingleSelection";

function ChainNameSingleSelection() {
  const {
    fields,
    setFields,
    translate: t,
  } = useBatchApproveAllowanceFormContext();
  const label = t("chain_name");

  const onChange = (e: SelectChangeEvent<string>) => {
    setFields((prev) => ({
      ...prev,
      chainName: e.target.value,
      currency: "",
      spenderAddress: "",
      isSmartAccount: false,
      isFreeBandwidthOnly: false,
      maxNumberOfAddresses: "1000",
    }));
  };

  return (
    <>
      <div>{label}</div>
      <ChainNameSelection
        fieldName={label}
        value={fields.chainName}
        onChange={onChange}
      />
    </>
  );
}

export default ChainNameSingleSelection;
